<template>
    <v-page-data-table
            title="权限组管理"
            key-name="id"
            :fields="fields"
            ref="producer"
            @create="onDetail"
            :height="535"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="PERMISSION_DELETE"
            query-api="PERMISSION_QUERY">

        <template v-slot:name="{item}">
            <v-link-text :text="item.name" @click="onDetail(item)"></v-link-text>
        </template>
    </v-page-data-table>
</template>

<script>
    import FndPermissionQueryFields from "./fields/FndPermissionQuery";
    import _ from 'lodash';

    export default {
        name: "ProducerQuery",
        data() {
            return {
                fields: FndPermissionQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '创建权限组',
                        color: 'primary',
                        icon: "mdi-lock",
                        action: 'create'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("permissionDetail", {id: id});
            }
        }
    }
</script>
